export default __webpack_public_path__ + "static/media/etavastaanotto-lightblue.46d3bd7e.svg";